import React from 'react';
import { Button, Paper, Box } from '@mui/material';
import useStyles from './styles';

import { Grid } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Pagination from '@mui/material/Pagination';
import { PAGE_LEVEL_SCRIPT_CONFIG_MODES } from '../../../../../../core/constants';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { usePageLevelScriptConfigContext } from '../../../../../../Contexts/PageLevelScriptConfigContext';
import SinglePageLevelScriptConfig from './Components/SinglePageLevelScriptConfig';

/**
 * PageLevelScriptConfigGenerator is a component used for creating, updating
 * page level script config.
 * It provides a user interface for adding, deleting, and saving individual page configs.
 *
 * The component makes use of `PageLevelScriptConfigContext` for state management
 */
const PageLevelScriptConfigGenerator = () => {
	const classes = useStyles();
	const {
		pageLevelScriptConfig,
		pageLevelScriptConfigMode,
		setPageLevelScriptConfigMode,
		savePageLevelScriptConfigPages,
		pageLevelScriptConfigPage,
		setPageLevelScriptConfigPage,
		handlePageLevelScriptConfigAddPage,
		deletePageLevelScriptConfigPage
	} = usePageLevelScriptConfigContext();

	const handleSavePage = async () => {
		await savePageLevelScriptConfigPages();
	};

	const handleChange = (event, value) => {
		setPageLevelScriptConfigPage(value);
	};
	const isCurrentPageLevelScriptConfigDeletable = () => {
		return !!pageLevelScriptConfig?.[pageLevelScriptConfigPage - 1]?.isDeletable;
	};

	const handleBackArrowButtonClick = () => {
		if (pageLevelScriptConfigMode === PAGE_LEVEL_SCRIPT_CONFIG_MODES.CREATE_PAGE_CONFIG) {
			setPageLevelScriptConfigMode(PAGE_LEVEL_SCRIPT_CONFIG_MODES.SITE_LEVEL_CREATE_PAGE_CONFIGS);
		} else {
			setPageLevelScriptConfigMode(PAGE_LEVEL_SCRIPT_CONFIG_MODES.SITE_LEVEL_UPDATE_PAGE_CONFIGS);
		}
	};

	return (
		pageLevelScriptConfig && (
			<Paper className={classes.container}>
				<Grid container spacing={2}>
					<Grid item xs={1}>
						<ArrowBackIcon
							color="primary"
							fontSize="large"
							style={{ cursor: 'pointer' }}
							onClick={handleBackArrowButtonClick}
						/>
					</Grid>
					<Grid item xs={5}>
						<Pagination
							count={pageLevelScriptConfig.length}
							shape="rounded"
							page={pageLevelScriptConfigPage}
							onChange={handleChange}
						/>
					</Grid>
					<Grid item xs={6} className={classes.buttonWrapper}>
						<Button variant="contained" onClick={handlePageLevelScriptConfigAddPage}>
							Add Page
						</Button>
						{pageLevelScriptConfig.length > 0 && isCurrentPageLevelScriptConfigDeletable() ? (
							<Button
								variant="contained"
								onClick={() =>
									deletePageLevelScriptConfigPage(
										pageLevelScriptConfig[pageLevelScriptConfigPage - 1].id
									)
								}
							>
								Delete Page
							</Button>
						) : null}

						<Button variant="contained" onClick={handleSavePage}>
							Save Config
						</Button>
					</Grid>
				</Grid>
				<Box className={classes.wrapper}>
					{Object.keys(pageLevelScriptConfig).length > 0 ? (
						<SinglePageLevelScriptConfig
							config={pageLevelScriptConfig[pageLevelScriptConfigPage - 1]}
						/>
					) : null}
				</Box>
				<ToastContainer />
			</Paper>
		)
	);
};

export default PageLevelScriptConfigGenerator;
